exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".assistance-toggle-label[data-v-1dd925b7] {\n  font-size: 1.4em;\n  display: flex;\n}\n.assistance-toggle-label .checkbox-container[data-v-1dd925b7] {\n  width: 30px;\n}\n.assistance-toggle-label span[data-v-1dd925b7] {\n  /*margin-left: 8px;*/\n}\n.assistance-toggle-label input[type=checkbox][data-v-1dd925b7] {\n  transform: scale(1.4);\n}", ""]);

// exports
